export const opacity = {
  disabled: 0.6,
};
